<div class="dtf-olp">
<div *ngIf="isForm" style="margin: 50px;">
    <div style="box-sizing: border-box; padding: 1rem; ">
        <div
            style="display: block; padding-left: 1rem; padding-right: 1rem; padding-top: .5rem; padding-bottom: .5rem; border-radius: .125rem; border-bottom-left-radius: 0; border-bottom-right-radius: 0; background: black; margin-top: 5px;">
            <h2
                style="color: rgb(255, 255, 255); font-size: 1.25rem; font-family: helvetica neue, helvetica, sans-serif; display: block;">
                Payment Portal for Daimler Truck Financial Services USA LLC</h2>
        </div>
        <div
            style="border-top-style: solid; border-top-width: 1px; border-color: black;; padding: 1rem; border-style: solid; border-color: black; border-width: 1px;">
            <p style="text-align: center;">If a payment is submitted prior to 10:00 pm ET, the payment will be
                posted
                to your DTFS account the following business day with the effective payment date of current date.
            </p>
            <p style="text-align: center;">If a payment is submitted after 10:00 pm ET, the payment will be
                posted to
                your DTFS account in two business days, with the effective date of current date.</p>
            <p style="text-align: center;">For more self-service options, please use the following link to <a
                    href="https://daimler-truckfinancial.com/">Daimler-truckfinancial.com</a> and register your
                account by clicking “Register”.</p>
        </div>
    </div>
    <!-- form -->
    <div style="box-sizing: border-box; padding: 1rem;">
        <div
            style="padding-left: 1rem; padding-right: 1rem; padding-top: .5rem; padding-bottom: .5rem; border-radius: .125rem; border-bottom-left-radius: 0; border-bottom-right-radius: 0; background: black;">
            <h2
                style="color: rgb(255, 255, 255); font-size: 1.25rem; font-family: helvetica neue, helvetica, sans-serif; display: block;">
                Account Lookup</h2>
        </div>
        <div
            style="border-top-style: solid; border-top-width: 1px; border-color: black; padding: 1rem; border-style: solid; border-color: black; border-width: 1px; ">
            
            <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <!--Spinner on Login Load-->
                <div class="demo-container">
                    <span>{{ 'Invoice.Loading' | translate }}</span>
                    <div class="progress-bar">
                        <div class="progress-bar-value"></div>
                    </div>
                </div>
                <br>
            </div>

            <div *ngIf="this.error"
                style="color: red; display: flex; justify-content: center;  font-size: 15px;  font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                <p>Please supply the required information. An * indicates a required field.</p>
            </div>
            <br>
            <div *ngIf="validationerror" style="color: red; display: flex; justify-content: center;  font-size: 15px;  font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                Please verify your entered details.
            </div>
           
                <div class="form-container" style=" margin-left: 40%; margin-right: 50%;">
                    <form [formGroup]="form">
                        <div class="form-group">
                            <label for="field1" style="font-weight: bold;">Account Number*</label> <br>
                            <input id="field1" formControlName="field1" style="width: 230%;" [(ngModel)]="accountNumber"/>
                          </div>
                    
                          <div class="form-group">
                            <label for="field2" style="font-weight: bold;" >Company Name*</label> <br>
                            <input id="field2" formControlName="field2" style="width: 230%;"  [(ngModel)]="CompanyName"/>                         
                          </div>
                    
                          <div class="form-group">
                            <label for="field3" style="font-weight: bold;">Zip Code*</label> <br>
                            <input id="field3" formControlName="field3" style="width: 230%;" placeholder="xxxxx" max="5" [(ngModel)]="ZipCode"/>
                          </div>    
                    </form>
                </div>
                
            <div style="display:flex; flex-direction: row; gap:50px; justify-content: center;" class="mt-4">
            <div><button class="mbfs-button"
            style="color: rgb(255, 255, 255); background: black; opacity: 1; transition: color .15s ease-in; text-align: center; margin-left: 46%; margin-top: 1%;"
            (click)="Cancel()">Cancel</button></div>
            <div><button class="mbfs-button" *ngIf="GuestPay"
            style="color: rgb(255, 255, 255); background: black; opacity: 1; transition: color .15s ease-in; text-align: center; "
            (click)="Lookup()">Lookup</button></div>
            </div>
        </div>
    </div>
</div>



<div *ngIf="isTable" style="padding: 2%; margin-bottom: 6%;">

    <div style="margin-left: 1%; margin-top: 2%;">

    <h1>Account Information</h1>

    <p>For more self-service options, please use the
        Daimler-truckfinancial.com link at the bottom of the page.</p>
    </div>

    <div style="box-sizing: border-box; padding: 1rem; ">
        <div
            style="display: block; padding-left: 1rem; padding-right: 1rem; padding-top: .5rem; padding-bottom: .5rem; border-radius: .125rem; border-bottom-left-radius: 0; border-bottom-right-radius: 0; background: black; margin-top: 5px;">
            <h2
                style="color: rgb(255, 255, 255); font-size: 1.25rem; font-family: helvetica neue, helvetica, sans-serif; display: block;">
               Accounts</h2>
        </div>
        <div
            style="border-top-style: solid; border-top-width: 1px; border-color: black; padding: 1rem; border-style: solid; border-color: black; border-width: 1px;">

            <div *ngIf="loading" style="font-size: 15px;  font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                Loading...
            </div>

            <div *ngIf="amounterror" style="color: red;  font-size: 15px;  font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                The payment amount must be greater than zero and less than or equal to $2,000,000.00 including fees.
            </div>
            <div *ngIf="failureError" style="color: red;
                                      font-size: 15px;
                                      font-family: Verdana, Geneva, Arial, Helvetica, sans-serif; margin-bottom: 1%;">
                We are currently experiencing technical difficulties, Please try again later.
            </div>

            <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort >
                <!--US/EN Table loading-->
                <ng-container matColumnDef="{{column.name}}"
                    *ngFor="let column of initColumns; last as isLast; first as isFirst;">
                    
                     <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;">                 
                            <div> {{column.display}}</div>
                     </mat-header-cell>


                    <mat-cell *matCellDef="let element" style="justify-content: center;">

                        <span class="mobile-label">
                            <div > {{column.display}} :</div>
                        </span>

                        <div *ngIf="column.dispFormat=='companyname'" style="font-size: 14px;"> 
                            {{element[column.name]}}
                            
                        </div>
                        <div *ngIf="column.dispFormat==''" > 
                            {{element[column.name]}}
                           
                        </div>
                        <div *ngIf="column.dispFormat=='amountdue'"> 
                            {{element[column.name] | currency:'USD':true:'1.2-2'}}
                             
                        </div>
                        <div *ngIf="column.dispFormat=='paymentamount'"> 
                            <!-- <mat-form-field appearance="outline" style="width: 80%; margin-top: 15px;"> -->
                                $ <input matInput min="0" type="text" (keypress)="positiveNumberOnly($event)" maxlength="12" style="width:97px;"
                                    [(ngModel)]='element.paymentAmount' id="paymentamount" (keypress)="restrictToTwoDecimals($event, element[column.name])" 
                                    (focusout)="convertToDecimal(element)" />
                            <!-- </mat-form-field> -->
                            <span
                                *ngIf="(['0.00'].includes(element.paymentAmount)||element.paymentAmount>2000000)"
                                alt="" style="width: 5px;margin-left:5px;">
                                <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" style="width: 5px;margin-left:5px;">
                            </span>
                        </div>
                        <div *ngIf="column.dispFormat=='paybutton'"> 
                            <button class="mbfs-button" (click)="HostedCheckout()" [disabled]="this.loading && GuestPay" [ngStyle]="{'background-color': loading ? 'grey' : 'black'}">Pay</button>
                        </div>
                    </mat-cell>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="customerDetailsList">
                    <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
                        [attr.colspan]="displayedColumns.length">
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row" [class.example-expanded-row]="customerDetailsList === element"
                    (click)="customerDetailsList = customerDetailsList === element ? null : element">
                </mat-row>
                <mat-row *matRowDef="let row; columns: ['customerDetailsList']"
                    class="example-detail-row"></mat-row>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter

                    </td>
                    <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre
                    </td>
                </tr>

            </mat-table>
           
<br>
            <button class="mbfs-button" (click)="CancelPay()" style="float: right; background-color: black;">Cancel</button>
            <br>
        </div>
    </div>

</div>
</div>